import React from 'react';
import clsx from 'clsx';
import { Input } from '../../../_custom';
import { numberOnly } from '../../../../utils/utils';
import {
    BUSINESS_DETAILS_KEY,
    BUSINESS_REFERENCE_FIELD_KEYS,
    BUSINESS_REFERENCES_KEY,
    BUSINESS_REFERENCES_LABELS,
    MANDATE_APPLICANT_LABELS,
    MANDATE_APPLICANT_PHONE_COUNTRY_CODE_PREFIX,
} from '../../DealDrawerConstants';
import { BusinessReference, hasBusinessReferencesData, isReferencePhoneValid, normalizeBusinessReferences } from './businessDetailsTypes';
import styles from '../../ManageDealDrawer.module.scss';

interface BusinessReferencesFieldsProps {
    formData: Record<string, any>;
    handleChange: (key: string, value: any, importanceKey?: string | null) => void;
    readonly?: boolean;
}

const referencesKey = `${BUSINESS_DETAILS_KEY}.${BUSINESS_REFERENCES_KEY}`;

// Untouched references block writes null (deleted key), never an all-blank array.
export const BusinessReferencesFields: React.FC<BusinessReferencesFieldsProps> = ({ formData, handleChange, readonly }) => {
    const references = normalizeBusinessReferences(formData[referencesKey]);

    const updateReference = (index: number, key: keyof BusinessReference, value: string) => {
        const next = references.map((ref, i) => (i === index ? { ...ref, [key]: value } : ref));
        handleChange(referencesKey, hasBusinessReferencesData(next) ? next : null);
    };

    return (
        <>
            {references.map((reference, index) => {
                const referenceNumber = index + 1;
                const nameFieldId = `business-reference-${referenceNumber}-name`;
                const phoneFieldId = `business-reference-${referenceNumber}-phone`;
                return (
                    <React.Fragment key={index}>
                        <div className={styles.InputItem}>
                            <label htmlFor={nameFieldId} className={clsx(styles.InputLabel, styles.InputItemLabel)}>
                                {BUSINESS_REFERENCES_LABELS.nameLabel(referenceNumber)}
                            </label>
                            <div className={styles.FieldFullWidthWrapper}>
                                <Input
                                    id={nameFieldId}
                                    type="text"
                                    value={reference.name}
                                    placeholder={BUSINESS_REFERENCES_LABELS.namePlaceholder}
                                    onChange={(value: string) => updateReference(index, BUSINESS_REFERENCE_FIELD_KEYS.NAME, value)}
                                    containerClassName={styles.FieldControlSm}
                                    disabled={readonly}
                                    allowAllCharacters
                                    autoComplete="off"
                                    showFloatingLabel={false}
                                />
                            </div>
                        </div>

                        <div className={styles.InputItem}>
                            <label htmlFor={phoneFieldId} className={clsx(styles.InputLabel, styles.InputItemLabel)}>
                                {BUSINESS_REFERENCES_LABELS.phoneLabel(referenceNumber)}
                            </label>
                            <div className={styles.PhoneNumberInputWrap}>
                                <span className={styles.PhoneNumberPrefix}>{MANDATE_APPLICANT_PHONE_COUNTRY_CODE_PREFIX}</span>
                                <Input
                                    id={phoneFieldId}
                                    type="number"
                                    autoComplete="off"
                                    placeholder={MANDATE_APPLICANT_LABELS.phonePlaceholder}
                                    value={reference.phone}
                                    onChange={(value: string) =>
                                        updateReference(index, BUSINESS_REFERENCE_FIELD_KEYS.PHONE, numberOnly(value))
                                    }
                                    errorMessage={MANDATE_APPLICANT_LABELS.invalidPhoneMessage}
                                    isValid={isReferencePhoneValid(reference.phone)}
                                    disabled={readonly}
                                    showFloatingLabel={false}
                                    inputClassName={styles.PhoneNumberInputField}
                                    containerClassName={styles.FieldControlSm}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </>
    );
};
